/*
 * Cart panel behaviour (moved out of snippets/cart-panel.liquid).
 *
 * Loaded with `defer` right after the cart-panel markup, so the DOM below is
 * guaranteed to exist and jQuery (loaded synchronously in <head>) is ready.
 * Keeping this out of the snippet also keeps it out of the `?sections=cart-drawer`
 * response that is fetched and DOMParser-parsed on every cart update.
 */
(function () {
  if (window.__daalsCartPanelInit) return;
  window.__daalsCartPanelInit = true;

  var $ = window.jQuery;
  var IS_PRODUCT_PAGE = window.location.href.indexOf('/products/') !== -1;

  var runWhenIdle =
    window.__daalsRunWhenIdle ||
    function (fn) {
      if ('requestIdleCallback' in window) {
        requestIdleCallback(fn, { timeout: 400 });
      } else {
        setTimeout(fn, 1);
      }
    };

  /* ------------------------------------------------------------------ */
  /* Nosto placement                                                     */
  /* ------------------------------------------------------------------ */

  // The Liquid-rendered nosto markup lives in an inert <template> in the
  // snippet so this file can stay a static asset.
  function nostoHtml() {
    var tpl = document.getElementById('cart-panel-nosto-tpl');
    return tpl ? tpl.innerHTML : '';
  }

  function insertNosto(container) {
    if (!container) return;
    container.insertAdjacentHTML('afterbegin', nostoHtml());
  }

  function reloadNosto() {
    if (window.Nosto) {
      window.Nosto.reloadCart(['nosto_recommendation_cart_popup']);
    }
  }

  function initNostoPlacement() {
    if (window.innerWidth < 991) {
      insertNosto(document.querySelector('.mob-nosto'));
      reloadNosto();
    } else {
      insertNosto(document.querySelector('.cart-nosto-elem'));
    }
  }

  /* ------------------------------------------------------------------ */
  /* Dynamic CTA in sticky footer                                        */
  /* ------------------------------------------------------------------ */

  function syncStickyAddedState() {
    var stickyBtn = document.querySelector('.sticky-info-product .sticky-info-right button');
    if (!stickyBtn) return;

    var select = document.querySelector('#product-variants select');
    var variantId = select ? String(select.value) : '';

    var inCart = false;
    if (variantId) {
      var escaped = window.CSS && CSS.escape ? CSS.escape(variantId) : variantId.replace(/"/g, '\\"');
      inCart = !!document.querySelector('.cart-window [data-variant-id="' + escaped + '"]');
    }

    stickyBtn.classList.toggle('el-prod_added-state', inCart);
  }

  var debounceId;
  function scheduleSync() {
    clearTimeout(debounceId);
    debounceId = setTimeout(syncStickyAddedState, 80);
  }

  function setupDynamicSync() {
    syncStickyAddedState();

    var variantSelect = document.querySelector('#product-variants select');
    if (variantSelect) {
      variantSelect.addEventListener('change', syncStickyAddedState);
    }

    $('.Size select').on('change', scheduleSync);

    // The sticky button click itself is handled in daals-inp-click.js
    // (handleStickyAtcClick) so it never goes through jQuery trigger().
  }

  /* ------------------------------------------------------------------ */
  /* React to the cart sidebar being re-rendered                         */
  /* ------------------------------------------------------------------ */

  var sidebar = document.getElementById('cart-sidebar');
  var updatePending = false;
  var conversionTimer = null;

  function onCartSidebarUpdated() {
    updatePending = false;
    if (!sidebar) return;

    // Convert experiment: empty-cart conversion. Armed once per batch.
    if (typeof window.isInViewport !== 'undefined') {
      clearTimeout(conversionTimer);
      conversionTimer = setTimeout(function () {
        var $empty = $('.empty');
        if ($empty.length > 0 && window.isInViewport($empty)) {
          window._conv_q = window._conv_q || [];
          window._conv_q.push(['triggerConversion', '1004113052']);
        }
      }, 1000);
    }

    var mobNosto = document.querySelector('.mob-nosto');
    if (
      window.innerWidth < 601 &&
      mobNosto &&
      !mobNosto.querySelector('#nosto_recommendation_cart_popup')
    ) {
      insertNosto(mobNosto);
      reloadNosto();
    } else if (sidebar.classList.contains('pd-from-sfl')) {
      sidebar.classList.remove('pd-from-sfl');
      nextTimeUpdatePreOrderNote();
    }

    hideEmptyMattressContainers();

    if ($('.recently-viewed-products').length > 0) return;

    if (typeof window.initRecentlyViewed !== 'undefined') {
      window.initRecentlyViewed();
    }

    if (IS_PRODUCT_PAGE) {
      scheduleSync();
    }
  }

  if (sidebar) {
    // childList only, no subtree/attributes: the sidebar is re-rendered via
    // innerHTML which is a single childList record on #cart-sidebar. Anything
    // else (class toggles for the skeleton, currency rewrites, nosto inserts)
    // must not re-trigger this work inside the interaction's frame.
    var observer = new MutationObserver(function () {
      if (updatePending) return;
      updatePending = true;
      runWhenIdle(onCartSidebarUpdated);
    });
    observer.observe(sidebar, { childList: true });
  }

  /* ------------------------------------------------------------------ */
  /* Pre-order note handling                                             */
  /* ------------------------------------------------------------------ */

  var MONTHS = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];

  function getDaySuffix(day) {
    if (day >= 11 && day <= 13) return 'th';
    switch (day % 10) {
      case 1:
        return 'st';
      case 2:
        return 'nd';
      case 3:
        return 'rd';
      default:
        return 'th';
    }
  }

  // "2026-03-14" -> "14th March 2026"
  function preorderAvailability(date) {
    var dateParts = date ? date.split('-') : undefined;
    var year = dateParts[0];
    var monthNumber = dateParts[1];
    var day = dateParts[2];
    var monthName = MONTHS[parseInt(monthNumber) - 1];
    return parseInt(day) + getDaySuffix(parseInt(day)) + ' ' + monthName + ' ' + year;
  }

  function extractDateFromString(inputString) {
    var datePattern = /(\d{1,2}(?:st|nd|rd|th) \w+ \d{4})/g;
    var dates = [];
    var match;
    while ((match = datePattern.exec(inputString)) !== null) {
      dates.push(match[0]);
    }
    return dates.length > 0 ? dates : null;
  }

  function changeCartItem(itemID, quantity, properties, onSuccess) {
    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: { id: itemID, quantity: quantity, properties: properties },
      dataType: 'json',
      success: onSuccess || function () {},
      error: function (e, t) {
        Shopify.onError(e, t);
      },
    });
  }

  function nextTimeUpdatePreOrderNote() {
    $('#cart-sidebar .cart-item').each(function () {
      var $item = $(this);
      var itemDate = $item.attr('data-date');
      var itemID = $item.attr('data-item-key');
      var itemProperty = $item.attr('data-item-property');
      var quantity = $item.find('input.update-product').val();

      if (itemProperty === '' && itemDate !== '') {
        var itemPoperty = 'ready for delivery from ' + preorderAvailability(itemDate);
        changeCartItem(itemID, quantity, { 'Please-Note': itemPoperty }, function () {
          $("[data-id='" + itemID + "']")
            .closest('.cart-desc')
            .find('.cart-stock > div').html(`<p>
                         <img
                           class="clock lazy"
                           src="https://cdn.shopify.com/s/files/1/0652/7474/0952/files/clock.svg?v=1659955811"
                           loading="lazy">Arriving soon
                       </p>`);
        });
      }

      if (itemProperty !== '' && itemDate !== '') {
        var splitDate = extractDateFromString(itemProperty);
        var dateParts = splitDate && splitDate[0] ? splitDate[0].split(' ') : undefined;
        var day = parseInt(dateParts && dateParts[0], 10);
        var month = dateParts && dateParts[1];
        var year = parseInt(dateParts && dateParts[2], 10);
        var monthNumber = MONTHS.indexOf(month);
        var formattedMonth = (monthNumber + 1).toString().padStart(2, '0');
        var dateProperty = year + '-' + formattedMonth + '-' + day;
        var dateItem = new Date(itemDate);
        var dateCart = new Date(dateProperty);
        if (
          dateItem.getTime() !== dateCart.getTime() ||
          itemProperty.includes('Dispatched soon after')
        ) {
          var newCartProperty = 'ready for delivery from ' + preorderAvailability(itemDate);
          changeCartItem(itemID, quantity, { 'Please-Note': newCartProperty });
        }
      }

      if (itemProperty !== '' && itemDate === '') {
        changeCartItem(itemID, quantity, { _: '' });
      }
    });
  }

  /* ------------------------------------------------------------------ */
  /* Related products (legacy .related-product markup)                   */
  /* ------------------------------------------------------------------ */

  function addRelatedProduct(element) {
    var button = $(element);
    var relatedProductContainer = button.closest('.related-product');
    button.text('ADDING...');

    var productId = button.attr('pd_id');
    $.ajax({
      method: 'POST',
      url: '/cart/add.js',
      dataType: 'json',
      data: { quantity: 1, id: productId },
    })
      .done(function (resp) {
        button.text('ADDED');
        window.shopping_cart_type == 'sidebar'
          ? window.roar.updateCartSidebar(resp, !0)
          : window.roar.updateCart(a, !0);
        setTimeout(function () {
          document.querySelector('.cart-block-click').click();
          relatedProductContainer.hide();
          relatedPdAtcEventKlaviyo(relatedProductContainer);
        }, 300);
      })
      .fail(function () {
        button.text('ADD TO CART');
      });
  }

  function relatedPdAtcEventKlaviyo(relatedProductContainer) {
    var qvPdName = relatedProductContainer.find('.thumbnail img').attr('alt');
    var qvPdPrice = relatedProductContainer.find('.cart-prod-price .money').text();
    var qvPdId = relatedProductContainer.find('.cart-prod-price .related-add-to-cart-btn').attr('pd_id');
    var url = relatedProductContainer.find('.thumbnail a').attr('href');
    var imageURL = relatedProductContainer.find('.thumbnail img').attr('src');

    _learnq.push([
      'track',
      'Added to Cart',
      {
        Name: qvPdName,
        ProductID: qvPdId,
        Categories: 'Cart Panal Related Product',
        ImageURL: 'https:' + imageURL,
        URL: 'https://www.daals.co.uk' + url,
        Brand: 'daals',
        Price: qvPdPrice,
      },
    ]);
  }

  /* ------------------------------------------------------------------ */
  /* Frequently bought together (.cart-panel-rel-productitem)            */
  /* ------------------------------------------------------------------ */

  // set flag for single hit, initially = 0
  var add_to_cart_button_event = 0;

  // this is for desktop version "sidebar"
  $(document).on('click', '#cart_info .cart-panel-rel-productitem .rl-add-to-cart-btn', function () {
    var $item = $(this).parents('.cart-panel-rel-productitem');
    customAddToCart(
      $(this),
      $item.attr('rl-cart-properties'),
      $item.find('.sidebar-design-block .rl-select').val(),
      true
    );
  });

  // this is for mobile version "main page"
  $(document).on('click', '#content .cart-panel-rel-productitem .rl-add-to-cart-btn', function () {
    var $item = $(this).parents('.cart-panel-rel-productitem');
    customAddToCart(
      $(this),
      $item.attr('rl-cart-properties'),
      $item.find('.sidebar-design-block .rl-select').val(),
      'panel'
    );
  });

  // this is for desktop version "main page"
  $(document).on('click', '#content .cart-panel-rel-productitem .rl-add-to-cart-panel-btn', function () {
    var $item = $(this).parents('.cart-panel-rel-productitem');
    customAddToCart($(this), $item.attr('rl-cart-properties'), $(this).attr('single-variant-id'), 'panel');
  });

  $(document).on('click', '.btn-action.cart-display-variants', function () {
    var $item = $(this).parents('.cart-panel-rel-productitem');
    customAddToCart(
      $(this),
      $item.attr('rl-cart-properties'),
      $item.find('.main-cart-design-block .rl-select').val(),
      'panel'
    );
  });

  function customAddToCart(button, preorderNote, skuId, is_it_sidebar_request) {
    if (add_to_cart_button_event !== 0) return;
    // update flag for ongoing hit = 1
    add_to_cart_button_event = 1;

    var frequentlyProductContainer = button.parents('.cart-panel-rel-productitem');
    var isVariantsBtn = button.hasClass('cart-display-variants');

    if (!isVariantsBtn) {
      button.text('ADDING...');
    }

    var data = { quantity: 1, id: skuId };
    if (preorderNote) {
      data.properties = { 'Please-Note': preorderNote };
    }

    $.ajax({
      method: 'POST',
      url: '/cart/add.js',
      dataType: 'json',
      data: data,
    }).done(function (resp) {
      if (!isVariantsBtn) {
        button.text('ADDED');
      }

      // Preserves the original behaviour: the pre-order branch passed the
      // add.js response through, the plain branch passed the request flag.
      window.shopping_cart_type == 'sidebar'
        ? window.roar.updateCartSidebar(preorderNote ? resp : is_it_sidebar_request, !0)
        : window.roar.updateCart(a, !0);

      setTimeout(function () {
        frequentlyAtcEventKlaviyo(frequentlyProductContainer);
      }, 100);

      // update flag for another hit = 0
      add_to_cart_button_event = 0;
    });
  }

  // Klaviyo ATC Button
  function frequentlyAtcEventKlaviyo(frequentlyProductContainer) {
    var qvPdName = frequentlyProductContainer.find('.rl-product-item-title').text();
    var qvPdPrice = frequentlyProductContainer.find('.rl-product-item-regular-price').text();
    var qvPdId = frequentlyProductContainer.attr('pd_id');
    var url = frequentlyProductContainer.find('.rl-product-item-title').attr('href');
    var imageURL = frequentlyProductContainer.find('.rl-product-item-main-image').attr('src');

    _learnq.push([
      'track',
      'Added to Cart',
      {
        Name: qvPdName,
        ProductID: qvPdId,
        Categories: 'Frequently bought together product',
        ImageURL: 'https:' + imageURL,
        URL: 'https://www.daals.co.uk' + url,
        Brand: 'daals',
        Price: qvPdPrice,
      },
    ]);
  }

  //SELECT SIZE
  function initSizeSelects() {
    var $selects = $('.rl-sizes select');
    if (!$selects.length) return;

    $selects.addClass('rl-sizes-select-event-attached');
    $selects
      .on('change', function () {
        var $selected = $(this).find('option:selected');
        var $item = $(this).parents('.cart-panel-rel-productitem');

        $item.find('.rl-product-item-regular-price').text($selected.attr('rl-price'));

        var dateArray = $selected.attr('preorder-availability');
        if (typeof dateArray !== 'undefined' && dateArray.length > 0) {
          try {
            var date = preorderAvailability(dateArray.trim());
            $item.attr('rl-cart-properties', 'ready for delivery from ' + date);
            $item.removeClass('preorder-active').addClass('preorder-active');
          } catch (error) {
            console.error('Error parsing dateArray:', error);
          }
        } else {
          $item.attr('rl-cart-properties', '');
          $item.removeClass('preorder-active');
        }
      })
      .trigger('change');
  }

  // Hide Matress Container if there was no matress
  function hideEmptyMattressContainers() {
    $('.matressRelatedProducts').each(function () {
      if ($(this).find('.mattressProductRowGrid').children().length === 0) {
        $(this).hide();
      }
    });
  }

  /* ------------------------------------------------------------------ */
  /* Boot                                                                */
  /* ------------------------------------------------------------------ */

  initNostoPlacement();

  if (IS_PRODUCT_PAGE) {
    setupDynamicSync();
  }

  nextTimeUpdatePreOrderNote();
  initSizeSelects();
  hideEmptyMattressContainers();

  // These used to be top-level functions in an inline <script>, i.e. globals.
  // Keep them reachable for anything else on the page that calls them.
  window.waitForElement = window.waitForElement || waitForElement;
  window.syncStickyAddedState = syncStickyAddedState;
  window.scheduleSync = scheduleSync;
  window.preorderAvailability = preorderAvailability;
  window.extractDateFromString = extractDateFromString;
  window.nextTimeUpdatePreOrderNote = nextTimeUpdatePreOrderNote;
  window.addRelatedProduct = addRelatedProduct;
  window.relatedPdAtcEventKlaviyo = relatedPdAtcEventKlaviyo;
  window.customAddToCart = customAddToCart;
  window.frequentlyAtcEventKlaviyo = frequentlyAtcEventKlaviyo;

  function waitForElement(predicate, callback, timer, frequency) {
    timer = timer === undefined ? 10000 : timer;
    frequency = frequency === undefined ? 25 : frequency;
    try {
      if (timer <= 0) {
        throw new Error('Timeout reached while waiting for condition: ' + predicate.toString());
      } else if (predicate && predicate()) {
        callback();
      } else {
        setTimeout(function () {
          waitForElement(predicate, callback, timer - frequency, frequency);
        }, frequency);
      }
    } catch (error) {
      return;
    }
  }
})();
